import React, { useState } from 'react';
import firebase from 'firebase/compat/app';

import { Link } from 'react-router-dom';
import './signin.css';

import { OAuthProvider } from "firebase/auth";
import 'firebase/compat/database'; 
import image1 from './img/authimage.png';
import Loader from './frontpage/Loader';

const firebaseConfig = {
  apiKey: "AIzaSyCI59gnHA9AZAANjoy082vht3fCgatchEg",
  authDomain: "hospital-management-syst-7e35d.firebaseapp.com",
  databaseURL: "https://hospital-management-syst-7e35d-default-rtdb.firebaseio.com",
  projectId: "hospital-management-syst-7e35d",
  storageBucket: "hospital-management-syst-7e35d.firebasestorage.app",
  messagingSenderId: "59517358381",
  appId: "1:59517358381:web:96f502e3832ddf1a8fc3a4",
  measurementId: "G-EYLWMBT9SP"
};

  
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}



const LoginForm=() =>{
    const [emailOrPhone, setEmailOrPhone] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [isFormOpen, setIsFormOpen] = useState(true);

  

    function signIn() {
        if (emailOrPhone.includes('@')) {
            signInEmailPassword(emailOrPhone, password);
        } else {
            signInWithPhone(emailOrPhone, password);
        }
    }

    function signInEmailPassword(emailOrPhone, password) {
        firebase.auth().signInWithEmailAndPassword(emailOrPhone, password)
            .then((userCredential) => {
                const user = userCredential.user;
                setMessage(`Signed in as ${user.email}`);
                window.location.href = '/profile';
            })
            .catch((error) => {
                setMessage(`Error: ${error.message}`);
            });
    }


   
    function signInWithGoogle() {
        const provider = new firebase.auth.GoogleAuthProvider();
        
        provider.addScope('email');
        provider.setCustomParameters({
            'login_hint': 'user@example.com',
            'prompt': 'select_account',
        });
    
        document.getElementById('googleSignInButton').disabled = true;
    
        firebase.auth().useDeviceLanguage();
    
        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                const user = result.user;
                const email = user.email;
                console.log('user:', user);
                console.log('Email:', email);
                setMessage(`Signed in with Google as ${user.displayName}`);
                
                const displayName = user.displayName.split(' ');
                setFirstName(displayName[0]);
                setLastName(displayName[1]);
                setEmail(email);
    
                // Check if user data exists before storing
                checkAndStoreUserData(user.uid, displayName[0], displayName[1], email);
    
                document.getElementById('googleSignInButton').disabled = false;
    
            })
            .catch((error) => {
                setMessage(`Error: ${error.message}`);
                document.getElementById('googleSignInButton').disabled = false;
            });
        }   
    
    const checkAndStoreUserData = (userId, firstName, lastName, email) => {
        fetch('https://us-central1-hospital-management-syst-7e35d.cloudfunctions.net/api/addUser', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ userId, firstName, lastName, email }),
          })
          .then(response => response.text())
          .then(data => {
            console.log(data);
            window.location.href = '/profile';
          })
          .catch((error) => {
            console.error('Error:', error);
          });
    };
    
    function signInWithMicrosoft() {
        const provider = new OAuthProvider('microsoft.com');
      
        document.getElementById('microsoftSignInButton').disabled = true;
    
            firebase.auth().signInWithPopup(provider)
            .then((result) => {
               
                const user = result.user;
                const email = user.email;
                setMessage(`Signed in with microsoft as ${user.displayName}`);
                const displayName = user.displayName.split(' ');
                setFirstName(displayName[0]);
                setLastName(displayName[1]);
                setEmail(email);
               
                checkAndStoreUserData(user.uid, displayName[0], displayName[1], email);
                console.log('Signed in with Microsoft:', user);
                document.getElementById('microsoftSignInButton').disabled = false;
               
            })
            .catch((error) => {
                setMessage(`Error: ${error.message}`);
                console.error('Microsoft sign-in error:', error);
                document.getElementById('microsoftSignInButton').disabled = false;

            });
    }

    /*
    function signInWithTwitter() {
        console.log("hi");
        var provider = new firebase.auth.TwitterAuthProvider();
        firebase.auth().useDeviceLanguage();
        
        firebase.auth().signInWithPopup(provider)
            .then((result) => {
            /** @type {firebase.auth.OAuthCredential} 
            var credential = result.credential;

            var token = credential.accessToken;
            var secret = credential.secret;

            // The signed-in user info.
            var user = result.user;
            console.log(user);
            document.getElementById('message').innerHTML = `Signed in with Twitter as ${user.displayName}`;
            window.location.href = 'http://127.0.0.1:5500/NiceAdmin/index.html';
        
            }).catch((error) => {
            document.getElementById('message').innerHTML = `Error: ${error.message}`;
            });
    }
    


    // sign in with git hub
    function signInWithGithub() {
        var provider = new firebase.auth.GithubAuthProvider();
        provider.addScope('repo');
        provider.setCustomParameters({
            'allow_signup': 'false'
        });

        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                var credential = result.credential;
                var token = credential.accessToken;
                var user = result.user;
                document.getElementById('message').innerHTML = `Signed in with Git hub as ${user.displayName}`;
                window.location.href = 'http://127.0.0.1:5500/NiceAdmin/index.html';
            }).catch((error) => {
                document.getElementById('message').innerHTML = `Error: ${error.message}`;
            })


    }*/

    function signInWithPhone(emailOrPhone,password) {
        var appVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
        console.log("signinwithphone  signed in");
        console.log(appVerifier);
        firebase.auth().signInWithPhoneNumber(emailOrPhone, appVerifier)
            .then((confirmationResult) => {
                // SMS sent. Prompt user to type the code from the message, then sign the user in with the confirmation code
                var code = prompt('Enter the verification code:', '');
                console.log(code);
                return confirmationResult.confirm(code);
            })
            .then((result) => {
                // User signed in successfully
                var user = result.user;
                console.log(user);
                document.getElementById('message').innerHTML = `Signed in with Phone as ${user.emailOrPhone}`;
                window.location.href = '/';
            })
            .catch((error) => {
                document.getElementById('message').innerHTML = `Error: ${error.message}`;
            });
    }

    function handleLoginClick(event) {
        event.preventDefault(); // Prevent default form submission behavior
        signIn(); // Call signIn function when login button is clicked
    }
    

    function closeForm() {
        setIsFormOpen(false);
    }
   
    return (
        
        <div className="container d-flex">
        <Loader/>
        <div className="image-container">
            <img src={image1} alt="Image Description" className="img-fluid" />
        </div>
        <div className="form-container2 align-content-center">
            <div className="align-content-end" id="recaptcha-container" />
            <form className="bg-light p-5 rounded">
                <p className="h4 mb-4 text-center">Sign in</p>
                
                <div className="form-group">
                    <input
                        type="text"
                        className="form-control mb-4"
                        id="emailOrPhone"
                        placeholder="Enter email or number"
                        required=""
                        value={emailOrPhone}
                        onChange={(e) => setEmailOrPhone(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <input
                        type="password"
                        className="form-control mb-4"
                        id="password"
                        placeholder="Enter password"
                        required=""
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <div className="text-center">
                    <button type="button" className="btn btn-success" onClick={handleLoginClick}>
                        Sign In
                    </button>
                </div><br></br>
                <p className="text-center">--Or with--</p>
                <div className="text-center">
                    <button id="googleSignInButton" onClick={signInWithGoogle} className="btn btn-outline-primary btn-block" >Google</button>
                </div>
                <div className="text-center">
                    Don't have an account?{' '}
                <Link to="/signup" className="text-decoration-underline text-primary">
                    Sign Up
                </Link>
                </div>
                <p id="message" className="mt-3 text-center">{message}</p>
            </form>
        </div>
    </div>
    );
}
export default LoginForm;